<template>
  <div style="display: none" />
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import keycloak from 'keycloak-js';

import { LOCAL_STORAGE_CPF } from '@/utils/constants/checkin.constants';
import { COLLABORATOR_WITHOUT_FCPF } from '@/utils/constants/datalayerMessage.constants';
import datalayerErrorMessage from '@/utils/helpers/message/datalayerErrorMessage.js';

const AuthService = keycloak({
  clientId: 'bifrost',
  realm: 'Funcionarios',
  url:
    process.env.currentEnv === 'prd'
      ? 'https://id.dasa.com.br/auth/'
      : 'https://id.azr-hml.dasaexp.io/auth/',
});

const Authenticate = AuthService.init({
  onLoad: 'login-required', // Login on application start and browser refresh
  promiseType: 'native', // To enable async/await
  'check-sso': false, // To enable refresh token
  checkLoginIframe: false, // To enable refresh token
});

export default {
  data() {
    return {
      user: null,
    };
  },
  async mounted() {
    this.clearBrand(); // Not sure if is working
    this.recoveryUser();
  },
  methods: {
    ...mapActions([
      'getMdmPatientByCpf',
      'createPatientJwt',
      'global/setCollaboratorFlow',
      'global/setVaccineFlow',
    ]),
    ...mapMutations({
      setPatientKeycloak: 'SET_PATIENT_KEYCLOAK',
      setCpfSearched: 'SET_CPF_SEARCHED',
      setClearCurrentBrand: 'SET_CLEAR_CURRENT_BRAND',
      setClearCurrentUnit: 'SET_CLEAR_CURRENT_UNIT',
    }),
    recoveryUser() {
      try {
        Authenticate.then(() => {
          this.user = AuthService.idTokenParsed;
          this.validatePatient();
        });
      } catch (error) {
        this.goNextStep('login_error', datalayerErrorMessage('recoveryUser', error));
      }
    },
    clearBrand() {
      this.setClearCurrentBrand();
      this.setClearCurrentUnit();
    },
    async validatePatient() {
      // Only checks if is a Dasa Collaborator with fCPF

      const accessLetter = this.user.preferred_username[0];
      const cpf = this.user.preferred_username.substring(1);

      if (accessLetter !== 'f') {
        return this.goNextStep(
          'login_error',
          datalayerErrorMessage('validatePatient', COLLABORATOR_WITHOUT_FCPF),
        );
      }

      const { id: mdmPatientId } = await this.getMdmPatientByCpf(cpf);
      sessionStorage.setItem(LOCAL_STORAGE_CPF, cpf);

      this.setCpfSearched(cpf);
      await this['global/setCollaboratorFlow'](true);
      await this['global/setVaccineFlow'](true);
      this.setPatientKeycloak(this.user);

      if (mdmPatientId) await this.createPatientJwt();

      this.submit();
    },
    submit() {
      this.goNextStep('select_brand');
    },
  },
};
</script>
